import React, {useState, useEffect } from 'react';
import authService from './api-authorization/AuthorizeService'
import MetaDB from './MetaDB';
import SupportUs from './features/supporters/SupportUs';
import EventsList from './features/events/EventsList';
import InContentAd from './ads/InContentAd';

function Home(props) {
    const [authenticated, setAuthenticated] = useState(false);

    useEffect(() => {
        async function fetchData() {
            setAuthenticated(await authService.isAuthenticated());
        }
        fetchData()
    }, []);

    return (
        <div>
            {authenticated && <SupportUs/>}
            <MetaDB/>
            <EventsList />
            <InContentAd />
        </div>
    );
}

export default Home;